import React from "react";

function HideIcon() {
  return (
    <span className="anticon anticon-hideicon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 66 58"
      >
        <g
          fill="none"
          fillRule="evenodd"
          stroke="none"
          strokeLinecap="square"
          strokeWidth="1"
        >
          <g
            stroke="currentColor"
            strokeWidth="1.5"
            transform="translate(-686 -224)"
          >
            <g transform="translate(493 131)">
              <g transform="translate(194 95)">
                <path d="M64.167 25.667s-9.625 19.25-32.084 19.25C9.625 44.917 0 25.667 0 25.667s9.625-19.25 32.083-19.25c22.459 0 32.084 19.25 32.084 19.25z"></path>
                <circle cx="32.083" cy="25.667" r="9.625"></circle>
                <path d="M3.208 54.542L57.75 0"></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
}

export default HideIcon;
